import { render, staticRenderFns } from "./table-column-child.vue?vue&type=template&id=2d7c3373&"
import script from "./table-column-child.vue?vue&type=script&lang=js&"
export * from "./table-column-child.vue?vue&type=script&lang=js&"
import style0 from "./table-column-child.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports